export const LOCKED_PRODUCT_DATA = {
  coach: {
    title: 'Coach',
    tagline: 'AI-powered financial coaching',
    valueProposition: 'Personalized financial advice, benefits eligibility checks, and debt support.',
    industryStats: [{ stat: 'Over 20,000', description: 'employees used Coach in the last 30 days' }],
  },
  budget: {
    title: 'Budget',
    tagline: 'Spending insights via connected banking',
    valueProposition: 'Help employees understand spending patterns with bank account insights.',
    industryStats: [{ stat: 'Over 12,000', description: 'employees used Budget in the last 30 days' }],
  },
  rewards: {
    title: 'Rewards',
    tagline: 'Discounts and cashback',
    valueProposition: 'Exclusive offers on groceries, entertainment, and everyday purchases.',
    industryStats: [
      { stat: 'Top Brands', description: 'Nike, AliExpress and Secret Sales are among our members favourite brands' },
      { stat: '31%', description: 'of employees visited Rewards in the past 30 days' },
    ],
  },
  sdl: {
    title: 'Salary Deducted Loans',
    tagline: 'Low-cost credit via payroll',
    valueProposition: 'Affordable loans with automatic payroll deduction.',
    industryStats: [
      { stat: 'Over 27,000', description: 'employees have taken out a salary deducted loan' },
      { stat: '£3,078', description: 'is the average loan amount' },
    ],
  },
  build: {
    title: 'Workplace Savings',
    tagline: 'Automated savings from pay',
    valueProposition: 'Help employees build emergency funds with payroll-linked savings.',
    industryStats: [
      { stat: '£83.9M', description: 'of savings by Stream members' },
      { stat: '£63', description: 'average monthly savings per saver' },
    ],
  },
};
